var _path, _path2, _path3, _path4, _rect, _rect2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignExecutive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6638 5.53476C11.3198 5.53476 10.8642 5.52714 10.2968 5.52714C8.9133 5.52714 7.77562 4.382 7.77562 2.98543V0.535139C7.77562 0.342377 7.62179 0.185425 7.43086 0.185425H3.40086C1.52013 0.185425 0 1.72904 0 3.62085V11.8304C0 13.8151 1.59255 15.4235 3.55778 15.4235H9.55909C11.433 15.4235 12.9524 13.8898 12.9524 11.9965V5.87762C12.9524 5.68409 12.7992 5.5279 12.6076 5.52866C12.2855 5.53095 11.8992 5.53476 11.6638 5.53476Z",
    fill: "#6EC2D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58796 0.617705C9.36015 0.380752 8.96243 0.5438 8.96243 0.872181V2.88132C8.96243 3.72399 9.65653 4.41732 10.4992 4.41732C11.0302 4.42342 11.7678 4.42494 12.3941 4.42342C12.7148 4.42266 12.8779 4.03942 12.6554 3.8078C11.8516 2.97199 10.4123 1.47409 9.58796 0.617705Z",
    fill: "#6EC2D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17065 7.72729H8.31847C8.63162 7.72729 8.88609 7.981 8.88609 8.29414C8.88609 8.60729 8.63162 8.86176 8.31847 8.86176H4.17065C3.8575 8.86176 3.60379 8.60729 3.60379 8.29414C3.60379 7.981 3.8575 7.72729 4.17065 7.72729Z",
    fill: "#C2EBF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27352 10.7704H4.17065C3.8575 10.7704 3.60379 11.0241 3.60379 11.3373C3.60379 11.6504 3.8575 11.9049 4.17065 11.9049H8.27352C8.58666 11.9049 8.84114 11.6504 8.84114 11.3373C8.84114 11.0241 8.58666 10.7704 8.27352 10.7704Z",
    fill: "#C2EBF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.9762,
    y: 6.54256,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    fill: "#6EC2D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9762,
    y: 6.54256,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3714 11.3862C13.4341 11.4457 13.4717 11.5273 13.4717 11.6151C13.4717 11.7029 13.4341 11.7844 13.3714 11.844L11.3988 13.6818C11.2733 13.8009 11.0726 13.7915 10.9567 13.666C10.9002 13.6065 10.8719 13.528 10.8719 13.4527C10.8719 13.3681 10.9065 13.2804 10.9723 13.2176L12.3616 11.9193H8.93697C8.76452 11.9193 8.62333 11.7782 8.62333 11.6057C8.62333 11.4332 8.76452 11.2921 8.93697 11.2921H12.3616L10.9723 10.0032C10.8468 9.88399 10.8375 9.68954 10.9567 9.56102C11.0758 9.43558 11.2733 9.42933 11.3988 9.54535L13.3714 11.3862Z",
    fill: "#DDF7FD",
    stroke: "#DDF7FD",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignExecutive);
export default __webpack_public_path__ + "static/media/assignExecutive.fd661e97bc8df395c010c399b5361416.svg";
export { ForwardRef as ReactComponent };